var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M18 8.96a8.94 8.94 0 0 0-1.394-4.792A9 9 0 0 0 12.858.859a9.03 9.03 0 0 0-9.55 1.156A8.97 8.97 0 0 0 .463 6.122a8.94 8.94 0 0 0-.201 4.985 8.96 8.96 0 0 0 2.504 4.321A9 9 0 0 0 7.2 17.747v21.74c0 .477.095.948.28 1.388 0 0 1.047.092 1.171.105.124.014.326.014.405.014s.282 0 .369-.014c.087-.013 1.095-.105 1.095-.105.185-.44.28-.911.28-1.388v-21.74a9.02 9.02 0 0 0 5.168-3.118A8.96 8.96 0 0 0 18 8.96m-6.3 0A2.71 2.71 0 0 1 9.206 7.3a2.68 2.68 0 0 1 .585-2.932 2.7 2.7 0 0 1 2.942-.583 2.684 2.684 0 0 1 .876 4.388 2.7 2.7 0 0 1-1.909.787"
  })));
};
export default SvgPin;